import { t } from 'i18next'

import type { AxiosErrorMap } from '@/infra/http'
import { showToast } from '@/infra/sonner'
import { regexParaCodigoProduto } from '@/utils/regex'

const acaoMap = {
  DUPLICAR: t('proposta:pages.proposta_ativa.duplicar'),
  REVISAR: t('proposta:pages.proposta_ativa.revisar'),
  LANCAR: t('proposta:pages.proposta_ativa.lancar'),
}

export const handleRevisarDuplicarPropostaError = (error: AxiosErrorMap, acao: 'DUPLICAR' | 'REVISAR' | 'LANCAR') => {
  const erroStatusPropostaInvalido = error?.response?.data?.find((e) => e.code === 'PROPOSAL_NOT_REVOKED_OR_REJECTED')
  if (erroStatusPropostaInvalido) {
    showToast({ message: t('proposta:pages.proposta_ativa.errors.status_invalido'), variant: 'error' })
    return
  }

  const erroProdutosNaoDisponiveis = error?.response?.data?.find(
    (e) => e.code === 'PRODUCTS_OF_THE_PROPOSAL_ARE_AVAILABLE',
  )
  if (erroProdutosNaoDisponiveis) {
    const msg = erroProdutosNaoDisponiveis.message
    const numeroProduto = regexParaCodigoProduto.exec(msg)?.[1]

    if (acao === 'LANCAR') {
      showToast({
        message: t('proposta:erros.produto_indisponivel', { code: numeroProduto }),
        variant: 'error',
      })
      return
    }
    showToast({
      message: t('proposta:pages.proposta_ativa.errors.produtos_nao_disponiveis', {
        numeroProduto,
        acao: acaoMap[acao],
      }),
      variant: 'error',
    })
    return
  }

  const erroCondicaoTabelaPreco = error?.response?.data?.find((e) => e.code === 'INVALID_PRICING_TABLE')
  if (erroCondicaoTabelaPreco) {
    const msg = erroCondicaoTabelaPreco.message
    const numeroProduto = regexParaCodigoProduto.exec(msg)?.[1]

    showToast({
      message: t('proposta:pages.proposta_ativa.errors.tabela_preco_vigente', {
        numeroProduto,
        acao: acaoMap[acao],
      }),
      variant: 'error',
    })
    return
  }

  const erroVagaPadraoIndisponivel = error?.response?.data?.find((e) => e.code === 'STANDARD_PARKING_UNAVAILABLE')
  if (erroVagaPadraoIndisponivel) {
    if (acao === 'REVISAR') {
      showToast({
        message: t('proposta:erros.revisar.vaga_padrao_indisponivel'),
        variant: 'error',
      })
      return
    }

    showToast({
      message: t('proposta:erros.vaga_padrao_indisponivel'),
      variant: 'error',
    })
    return
  }

  const erroAcessorioZeradoSemUnidadeVinculada = error?.response?.data?.find(
    (e) => e.code === 'ZERO_VALUE_ACCESSORY_WITHOUT_LINKED_UNIT',
  )
  if (erroAcessorioZeradoSemUnidadeVinculada) {
    showToast({
      message: t('proposta:erros.acessorio_zerado_sem_unidade_vinculada'),
      variant: 'error',
    })
    return
  }

  const erroPrazoDiferenteDe40Meses = error?.response?.data?.find((e) => e.code === 'INVALID_TERM_NOT_40_MONTHS')
  if (erroPrazoDiferenteDe40Meses) {
    const msg = erroPrazoDiferenteDe40Meses.message
    const numeroProduto = regexParaCodigoProduto.exec(msg)?.[1]
    showToast({
      message: t('proposta:erros.prazo_diferente_de_40_meses', { numeroProduto }),
      variant: 'error',
    })
    return
  }

  showToast({
    message: t('common:errors_gerais.padrao'),
    variant: 'error',
  })
}
